import React from "react";
import {
  Tooltip,
  Select,
  FormGroup,
  TextInput,
  Button,
  FormGroupLabel,
} from "gumdrops";
import { Link } from "react-router-dom";

const Hype = () => {
  return (
    <div className="gds-layout__container">
      <h1 className="gds-text--header-sm ">Hype Upload</h1>
      <div className="gds-container -color-bg-white -color-bd-lt-2 -p-h-3 -p-b-3">
        <FormGroup className="-m-b-3">
          <FormGroupLabel text="Folder Name" />
          <Select
            className=""
            context={undefined}
            customName="name"
            customValue="value"
            name="unit-type"
            onChange={function noRefCheck() {}}
            options={[
              {
                name: "unassigned",
                value: "1",
              },
              {
                name: "Boost Mobile",
                value: "2",
              },
              {
                name: "Make this a search to select",
                value: "3",
              },
            ]}
            size="sm"
            style={{ width: "50%" }}
            value="2"
          />
        </FormGroup>
        <FormGroupLabel text="Hype Files" />
        <div className="gds-container -p-a-0 -color-bd-lt-2 -m-b-2">
          <div className="gds-table--responsive gds-table--striped">
            <table className="gds-table gds-table--sm">
              <thead>
                <tr className="gds-table__row">
                  <th
                    className="gds-table__header gds-table__header--white"
                    style={{ width: 300 }}
                  >
                    Hype Zip File
                  </th>
                  <th
                    className="gds-table__header gds-table__header--white -text-left"
                    style={{ width: 100 }}
                  >
                    File Size
                  </th>
                  <th className="gds-table__header gds-table__header--white -text-left">
                    Name
                  </th>

                  <th className="gds-table__header gds-table__header--white -text-left">
                    Unit Type
                  </th>
                  <th
                    className="gds-table__header gds-table__header--white"
                    style={{ width: 46 }}
                  ></th>
                </tr>
              </thead>
              <tbody>
                <tr className="gds-table__row">
                  <td>
                    <label className="gds-form-group__file gds-form-group__file--xs">
                      <input
                        className="gds-form-group__file-input"
                        type="file"
                        id="file-input-0"
                      />
                      <span
                        className="gds-form-group__file-indicator gds-form-group__file-indicator--xs"
                        data-button-label="Browse"
                        data-input-label="Example File Input"
                      ></span>
                    </label>
                  </td>
                  <td>254.38kb / 450kb</td>
                  <td>
                    <TextInput
                      className=""
                      name="name"
                      onChange={() => console.log("text input")}
                      placeholder="Unit Name"
                      size="xs"
                      type="text"
                      value="isa_blue.hyperesources"
                    />
                  </td>
                  <td>
                    <FormGroup>
                      <Select
                        className=""
                        context={undefined}
                        customName="name"
                        customValue="value"
                        name="unit-type"
                        onChange={function noRefCheck() {}}
                        options={[
                          {
                            name: "bananas",
                            value: "1",
                          },
                          {
                            name: "apples",
                            value: "2",
                          },
                          {
                            name: "strawberries",
                            value: "3",
                          },
                          {
                            name: "limes",
                            value: "4",
                          },
                        ]}
                        size="xs"
                        style={{}}
                        value="2"
                      />
                    </FormGroup>
                  </td>
                  <td className="-text-center">
                    <Tooltip text="Delete Unit" position="left">
                      <button className="icon">
                        <i className="fas fa-trash" />
                      </button>
                    </Tooltip>
                  </td>
                </tr>
              </tbody>
            </table>
            <hr className="-color-bd-lt-2 -m-a-0" />
            <div className="gds-flex gds-flex--justify-end -p-a-2">
              <Tooltip text="Add Unit" position="left">
                <Button context="outline" size="xs">
                  <i className="fas fa-fw fa-plus" />
                </Button>
              </Tooltip>
            </div>
          </div>
        </div>
        <div className="gds-flex gds-flex--justify-end -m-t-3">
          <Link
            to="/"
            className="gds-button gds-button--outline gds-button--sm"
          >
            Cancel
          </Link>
          <Link
            to="/"
            className="gds-button gds-button--primary gds-button--sm -m-l-2"
          >
            Submit
          </Link>
        </div>
      </div>
    </div>
  );
};

export default Hype;
